import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { BadgeCheck } from "lucide-react";
import { API } from "@/data/catalog";
import { GoldStars } from "@/components/GoldStars";

// Recensioni REALI inserite da Admin (POST /api/admin/testimonials). Nessun contenuto fittizio: la sezione non compare finché la lista è vuota.
export const RealTestimonials = () => {
  const { t, i18n } = useTranslation();
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/public/testimonials`, { params: { lang: i18n.language?.slice(0, 2) } }).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, [i18n.language]);
  if (!items.length) return null;
  return (
    <section id="testimonianze" className="py-12 sm:py-24 bg-[#F5F1E8] text-[#0b0b0b]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.3em] text-[#8a6d1d] mb-3">{t("testimonials.eyebrow")}</p>
        <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl">{t("testimonials.title")}</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {items.map((it) => (
            <figure key={it.id} className="bg-white border border-black/[0.06] rounded-2xl p-6 flex flex-col" data-testid={`testimonial-${it.id}`}>
              <div className="flex items-center justify-between gap-3 mb-4">
                <GoldStars size={14} gap={1.5} count={it.rating} />
                <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#8a6d1d]"><BadgeCheck className="w-3.5 h-3.5" />{t("testimonials.verified")}</span>
              </div>
              <blockquote className="text-sm leading-relaxed text-[#2a2825] flex-1">“{it.text}”</blockquote>
              <figcaption className="mt-5 text-xs">
                <span className="font-bold">{it.author}</span>
                {(it.business || it.sector) && <span className="text-[#6b665e]"> · {[it.business, it.sector].filter(Boolean).join(" · ")}</span>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
